import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { Deposit } from './types'
import { $params } from '../../../../features/router'

export const depositMounted = createEvent()
export const setDeposit = createEvent<Deposit>()
export const setDepositBan = createEvent()
export const setDepositDelete = createEvent()
export const $deposit = restore(setDeposit, {
  transactionId: '',
  client: {
    clientId: '',
    email: '',
    fullName: '',
    partner: false,
  },
  isAuto: false,
  processingProvider: '',
  processingMethod: '',
  status: '',
  initialAmount: '',
  initialCurrency: '',
  clientAmount: '',
  clientCurrency: '',
  clientCommission: '',
  companyCommission: '',
  commissionCurrency: '',
  createdAt: '',
  updatedAt: '',
  manager: {
    userId: '',
  },
})

export const getDeposit = fx<void, Deposit>({
  method: 'GET',
  url: '/deposit/',
})

export const banDeposit = fx<Deposit, void>({
  method: 'PUT',
  url: '/deposit/',
})

export const deleteDeposit = fx<Deposit, void>({
  method: 'DELETE',
  url: '/deposit/',
})

sample({
  clock: depositMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.depositID
    }
    return {
      url: `/deposit/${id}`,
    }
  },
  target: getDeposit,
})

sample({
  clock: setDepositBan,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.depositID
    }
    return {
      url: `/deposit/${id}`,
    }
  },
  target: banDeposit,
})

sample({
  clock: setDepositDelete,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.depositID
    }
    return {
      url: `/deposit/${id}`,
    }
  },
  target: deleteDeposit,
})

// update profile model

sample({
  clock: getDeposit.doneData,
  fn: (doneData) => doneData.body,
  target: setDeposit,
})
